import React from "react";

export default function CircularLoader({
  size = 20,
  color = "text-brand",
  className = "",
}) {
  const borderSize = Math.max(2, Math.round(size / 10)); // auto-calc thickness

  return (
    <div
      className={`relative ${className}`}
      style={{ width: size, height: size }}
    >
      {/* Background Circle */}
      <div
        className="absolute rounded-full border-ui-border"
        style={{
          borderWidth: borderSize,
          width: size,
          height: size,
        }}
      />

      {/* Spinning Arc */}
      <div
        className={`absolute rounded-full border-transparent animate-spin ${color}`}
        style={{
          borderWidth: borderSize,
          borderTopColor: "currentColor",
          width: size,
          height: size,
        }}
      />
    </div>
  );
}
